import React from 'react';
import "./CertificationCertificate.css";
import certificateImg from "./images/img4.png";







const CertificationCertificate = () => {
  return (
    <div className="page-container">
      {/* מיכל משותף לתעודה ולפס שמתחתיה */}
      <div className="content-layout">

      {/* תמונת התעודה בדיוק באמצע */}
     <div className="certificate-wrapper">
      <img
        src={certificateImg}
        alt="Certificate"
        className="certificate-img"
      />
    </div>


        {/* הפס האדום - עכשיו מתחיל בדיוק מתחת לתעודה */}
        <div className="red-stripe"></div>
        
      </div>
    </div>
  );
};

export default CertificationCertificate;
